import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Form, Input, Upload, Spin, Table, Typography, message, Button, Tooltip, Select } from 'antd';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { PageHeader } from '../../components/page-headers/page-headers';
import { Main, BasicFormWrapper, TableWrapper } from '../styled';
import EmailEditor from 'react-email-editor';
import { useAuth } from '../../context/auth.context';
import useApiFetch from '../../hooks/useApiFetch';

// const { Option } = Select;
// const dateFormat = 'YYYY/MM/DD';
const EditResponseTemplate = ({ match }) => {
    const { apiClient } = useAuth();
    const [templateData, setTemplateData] = useState(null);
    const [isEditorLoaded, setIsEditorLoaded] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [subject, setSubject] = useState('');
    const [form] = Form.useForm();
    const emailEditorRef = useRef(null);

    const {
        data: template,
        error: templatesError,
        loading: templatesLoading,
    } = useApiFetch(`/api/notification-templates?templateId=${match.params.id}`, (data) => data?.data?.[0]);

    const history = useHistory();

    useEffect(() => {
        form.setFieldsValue();
    }, [form, templateData]);
    useEffect(() => {
        if (template) {
            setSubject(template.subject);
        }
    }, [template]);

    const exportHtmlContent = () =>
        new Promise((res, rej) => {
            const unlayer = emailEditorRef.current?.editor;
            unlayer?.exportHtml((data) => {
                const { design, html } = data;
                const parser = new DOMParser();
                const parsedHtml = parser.parseFromString(html, 'text/html');

                if (!parsedHtml.head) {
                    const head = parsedHtml.createElement('head');
                    parsedHtml.documentElement.insertBefore(head, parsedHtml.documentElement.firstChild);
                }
                const ogTitle = document.createElement('meta');
                ogTitle.setAttribute('property', 'og:title');
                ogTitle.content = '{{ogTitle}}'; //form.getFieldValue('title');

                const ogDescription = document.createElement('meta');
                ogDescription.setAttribute('property', 'og:description');
                ogDescription.content = '{{ogDescription}}'; // form.getFieldValue('description');

                const ogImage = document.createElement('meta');
                ogImage.setAttribute('property', 'og:image');
                ogImage.content = '{{ogImage}}';

                parsedHtml.head.appendChild(ogTitle);
                parsedHtml.head.append(ogDescription);
                parsedHtml.head.append(ogImage);

                const modifiedHtmlString = new XMLSerializer().serializeToString(parsedHtml);

                res({
                    html: modifiedHtmlString,
                    design,
                });
            });
        });

    const onEditorReady = (unlayer) => {
        // editor is ready
        // you can load your template here;
        // the design json can be obtained by calling
        // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)
        // const templateJson = { DESIGN JSON GOES HERE };
        setIsEditorLoaded(true);
        if (typeof template.emailDesign === 'string') {
            unlayer.loadDesign(JSON.parse(template.emailDesign));
        } else {
            unlayer.loadDesign(template?.emailDesign);
        }
    };

    const updateTemplate = async () => {
        try {
            setIsSaving(true);
            const { html: htmlContent, design } = await exportHtmlContent();
            let updatedTemplateData = {
                htmlContent,
                // emailDesign: design,
                subject,
            };
            const initialTemplateData = {
                htmlContent: template.htmlContent,
                // emailDesign: template.emailDesign,
                subject: template.subject,
            };

            // compare initial and updated data to see if there are any changes
            if (JSON.stringify(initialTemplateData) === JSON.stringify(updatedTemplateData)) {
                setIsSaving(false);
                message.info('No changes detected');
                history.push(`/admin/notification-templates/${template.to}`);
                return;
            }

            const updatedTemplate = await apiClient.put(`/api/notification-templates?templateId=${match.params.id}`, {
                ...updatedTemplateData,
                emailDesign: design,
            });
            setIsSaving(false);
            message.success('Saved!');
            history.push(`/admin/notification-templates/${template.to}`);
        } catch (err) {
            setIsSaving(false);
            message.error('Error saving design');
        }
    };

    return (
        <>
            <PageHeader
                buttons={[
                    // <Button className="btn-add_new" size="default" key="1" type="primary">
                    //     <Link key="1" to="/admin/notification-templates">
                    //         View All
                    //     </Link>
                    // </Button>,
                ]}
                ghost
                title={template?.name}
            />
            <Main>
                <BasicFormWrapper>
                    {templatesLoading ? (
                        <div className="">
                            <Spin />
                        </div>
                    ) : (
                        <>
                            <Form.Item label="Subject">
                                <Input
                                    name="subject"
                                    value={subject}
                                    onChange={(e) => {
                                        setSubject(e.target.value);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Email Design">
                                <EmailEditor
                                    style={{ width: '100%' }}
                                    options={{
                                        displayMode: 'email',
                                        appearance: {
                                            features: {
                                                preview: true,
                                            },
                                        },
                                        amp: true,
                                        mergeTags: {
                                            organization: {
                                                name: 'Organization',
                                                mergeTags: {
                                                    name: { name: 'Name', value: '{{organization.name}}' },
                                                    website: { name: 'Website', value: '{{organization.website}}' },
                                                    address: { name: 'Address', value: '{{organization.address}}' },
                                                    phone: { name: 'Phone', value: '{{organization.phone}}' },
                                                    policyUrl: {
                                                        name: 'Policy URL',
                                                        value: '{{organization.policyUrl}}',
                                                    },
                                                    whatsapp: {
                                                        name: 'WhatsApp number',
                                                        value: '{{organization.whatsapp}}',
                                                    },
                                                    whatsappLink: {
                                                        name: 'WhatsApp chat link',
                                                        value: '{{organization.whatsappLink}}',
                                                    },
                                                    supportEmail: {
                                                        name: 'Support email',
                                                        value: '{{organization.supportEmail}}',
                                                    },
                                                },
                                            },
                                            contact: {
                                                name: 'Contact',
                                                mergeTags: {
                                                    name: { name: 'Name', value: '{{contact.name}}' },
                                                    email: { name: 'Email', value: '{{contact.email}}' },
                                                },
                                            },
                                            date: {
                                                name: 'Date & time',
                                                mergeTags: {
                                                    today: { name: 'Today', value: '{{today}}' },
                                                    time: { name: 'Time', value: '{{time}}' },
                                                    year: { name: 'Year', value: '{{year}}' },
                                                },
                                            },
                                        },
                                    }}
                                    minHeight={'85vh'}
                                    ref={emailEditorRef}
                                    onReady={onEditorReady}
                                />
                            </Form.Item>
                            <Row justify={'end'}>
                                <Form.Item>
                                    <Button
                                        size="large"
                                        disabled={!isEditorLoaded}
                                        onClick={updateTemplate}
                                        loading={isSaving}
                                        htmlType="submit"
                                        type="primary"
                                        style={{ marginLeft: 'auto' }}
                                    >
                                        {isSaving ? 'Saving...' : 'Update Template'}
                                    </Button>
                                </Form.Item>
                            </Row>
                        </>
                    )}
                </BasicFormWrapper>
            </Main>
        </>
    );
};

// AddNewCommunication.propTypes = {
//   match: PropTypes.object,
// };

export default EditResponseTemplate;
